"use client";

import { useState } from "react";

import { CarIcon, UserIcon } from "lucide-react";

import { StepNavigation } from "@/components/backoffice/step-navigation";
import {
  VehicleAssignmentStep,
  VehicleAssignmentStepProgress,
} from "@/components/backoffice/cat/vehicle-assignment/vehicle-assignment-step-progress";
import { VehicleAssignmentRetailSteps } from "@/components/backoffice/cat/vehicle-assignment/vehicle-assignment-retail-steps";
import { useStep } from "@/hooks/use-step-handler";

const uiText = {
  placeholder: {
    description: "Foo",
    title: "Foo",
  },
  steps: {
    clientInfo: {
      description: "Informations client",
      title: "Informations client",
    },
  },
};

const stepLimits = {
  max: 5,
  min: 1,
} as const;

const stepPlaceholder = (step: number): VehicleAssignmentStep => ({
  description: uiText.placeholder.description,
  icon: CarIcon,
  step,
  title: uiText.placeholder.title,
});

const stepsRetail: VehicleAssignmentStep[] = [
  stepPlaceholder(1),
  {
    description: uiText.steps.clientInfo.description,
    icon: UserIcon,
    step: 2,
    title: uiText.steps.clientInfo.title,
  },
  stepPlaceholder(3),
  stepPlaceholder(4),
  stepPlaceholder(5),
];

function VehicleAssignmentRetailFlow() {
  const { handleStepChange, step } = useStep();
  const [canProceed, setCanProceed] = useState(true);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-4 gap-8">
        <div className="col-span-1">
          <VehicleAssignmentStepProgress
            currentStep={step}
            steps={stepsRetail}
          />
        </div>

        <div className="col-span-3">
          <VehicleAssignmentRetailSteps onCanProceedChange={setCanProceed} />
          <StepNavigation
            isNextDisabled={step === 2 ? !canProceed : false}
            onNext={() => handleStepChange(Math.min(step + 1, stepLimits.max))}
            onPrevious={() =>
              handleStepChange(Math.max(step - 1, stepLimits.min))
            }
            showNext={step < stepLimits.max}
            showPrevious={step > stepLimits.min}
          />
        </div>
      </div>
    </div>
  );
}

export { VehicleAssignmentRetailFlow };
